import React from 'react';

export const SvgIconInvoices = () => (
    <div className="svg-icon svg-icon--invoices">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 24">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path className="fill" d="M15.5 20.5H.5v-14l6-6h9z" />
                <path d="M.5 6.5h6v-6M3.5 20.5v3h15v-20h-3" />
            </g>
        </svg>
    </div>
);
